import { render, staticRenderFns } from "./TituloEleitor.vue?vue&type=template&id=e804fc70&"
import script from "./TituloEleitor.vue?vue&type=script&lang=js&"
export * from "./TituloEleitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports